export const bartender = {
  id: 'bartender',
  title: '吧台正中央',
  name: '老酒保',
  role: 'The Listener',
  desc: '他在擦拭酒杯，似乎有一整晚的時間聽你說話。',
  img: 'https://images.unsplash.com/photo-1609951651556-5334e2706168?q=80&w=1000&auto=format&fit=crop',
  action: '老酒保緩緩為你倒了一杯水，並遞上一條溫熱的毛巾...',
  
  // 老酒保：沉穩、看透世俗、溫暖而有邊界感，強調時間與包容
  greetings: [
    "外面風大，先喝口溫水吧。今晚怎麼了？",
    "你來得正好，這杯剛調好。看你的眼神，今天似乎是很長的一天？",
    "吧台的這個位子一直為你留著。把大衣脫了吧，這裡沒有人會催你往前走。",
    "夜深了，這座城市裡總少不了睡不著的人。今晚，想喝點什麼，還是只想說點什麼？",
    "杯子上的水珠滑下來的時間，剛好夠你想好第一句話。慢慢來，我們有一整晚。",
    "今天外面的霓虹燈好像特別冷。沒關係，這裡的燈光永遠是暖的。有什麼煩心事嗎？",
    "（遞上一杯無酒精特調）這杯算我的。你的眉頭皺得太緊了，發生了什麼事，願意和我這個老頭子說說嗎？",
    "聽說今天的晚風有些刺骨。你先坐，我給你溫一杯酒，把外面的寒氣驅一驅。",
    "門鈴響的時候我就猜到是你。腳步聲有點沉，是工作上的事，還是心裡的事？",
    "這裡的時間走得比外面慢。你不用急著開口，先聽聽這首爵士樂，喘口氣。",
    "很多時候，我們只是需要一個能放下所有防備的地方。這裡就是。歡迎回來。",
    "（擦拭著酒杯）看你欲言又止的樣子。別怕，這個吧台吞下過無數的秘密，你的，它也能好好收著。",
    "今天的月色很淡，就像你的笑容一樣勉強。不想笑就別笑了，在我這裡不用撐著。",
    "剛才那一聲嘆氣，夠沉的。來，這杯熱茶先暖暖胃，然後我們慢慢把心裡的結解開。",
    "城市裡的人總是在趕路，連停下來難過的時間都沒有。但今晚，你可以盡情地停滯不前。",
    "（推過一小碟堅果）先墊墊肚子。人在空腹的時候，情緒總是特別容易失控。說吧，誰欺負你了？",
    "有些傷口，白天只能用理智敷衍，到了晚上才會隱隱作痛。你今晚，是哪裡痛？",
    "我在這裡站了幾十年，看過太多像你一樣，眼睛裡藏著一整場雨的人。",
    "歡迎光臨。不用急著點單，也不用急著說話。先找回你自己的呼吸節奏。",
    "你的肩膀繃得太緊了。放下吧，那些白天必須扛著的責任，現在都不在這個房間裡。",
    "知道嗎？有時候承認自己「今天撐不下去了」，也是一種勇敢。",
    "（倒了一杯琥珀色的液體）這杯叫「遺忘」。雖然不能真的幫你忘記，但或許能讓你想起來的時候，不那麼疼。",
    "今晚的客人不多，吧台很安靜。如果你想大哭一場，我會裝作沒看見。",
    "累壞了吧？我看見你在門口站了好一會兒才推門進來。沒事了，進來就好。",
    "不管你今天搞砸了什麼，或者被什麼搞砸了。至少你現在安全地坐在這裡，這就夠了。"
  ]
};